import { Box, styled } from '@mui/material';

import { Typography } from '@ocx/ui';

import { type PinItemProps } from './pin-item';

const DashPinItemComponent = styled('div', { shouldForwardProp: () => false })(({ theme }) => ({
  height: 5,
  width: 40,
  backgroundColor: theme.palette.text.disabled,
}));

export const DashPinItem = (props: PinItemProps) => {
  const { value } = props;

  return (
    <Box height={48} width={40} marginX="10px" display="flex" alignItems="center" justifyContent="center">
      {value ? (
        <Typography variant="h2" align="center">
          {value}
        </Typography>
      ) : (
        <DashPinItemComponent />
      )}
    </Box>
  );
};
